<script setup>
import Loading from '@/components/loading.vue';
import { swalError } from '@/helper';
import { retrieve_report } from '@/services/report';
import { computed, ref, onBeforeMount } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  report: {
    type: Object,
    required: true
  },
  character:{
    required: true,
    type: Object
  }
})

const packages = computed(()=>store.state.statistic.packages)
const packageObj = ref({})
const storeCharacter = ref({})
const store = useStore()
const traitOptions = ref()
const isLoading = ref(true)
onBeforeMount(async()=>{
  let response = await retrieve_report(props.report.id) // retrieve assign trait data
  store.dispatch('statistic/createPackage', {
    package: props.report.package_config, 
    assign_traits: response.result.data.included
  })
  packageObj.value = packages.value.find((packageObj)=> packageObj.config.id == props.report.package_config.id)
  storeCharacter.value = packageObj.value.characters.find((character)=> character.id == props.character.id)
  traitOptions.value = generateOption(props.character.traits)
  isLoading.value = false
})

function generateOption(traits){
  traits = traits.map(trait =>{
    let found = storeCharacter.value.trait_ids.find(temp_trait => temp_trait.id == trait.id)
    return {
      valueProp: trait.id,
      label: trait.name,
      disabled: found ? true : false
    }
  })
  return traits
}

function addTrait(character_id, package_id){
  if (storeCharacter.value.tempTrait.id == ''){
    swalError('Trait is empty')
    return
  }
  traitOptions.value = traitOptions.value.map(item => {
    if (storeCharacter.value.tempTrait.id == item.valueProp){
      return {
        ...item,
        disabled: true
      }
    }
    return {...item}
  })
  store.dispatch('statistic/updateTrait', {package_id, character_id})
}

function addTraitFooterBtn(character_id, package_type){
  document.getElementById('addTraitBtn-' +  package_type + character_id).click()
}

function removeTrait(character_id, package_id, trait_index, trait_id){
  // console.log("🚀 ~ removeTrait ~ trait_id:", trait_id)
  // console.log("🚀 ~ removeTrait ~ trait_index:", trait_index)
  traitOptions.value = traitOptions.value.map(item => {
    if (trait_id.id == item.valueProp){
      return {
        ...item,
        disabled: false
      }
    }
    return {...item}
  })
  // console.log("🚀 ~ addTrait ~ traitOptions:", traitOptions.value)
  store.dispatch('statistic/removeTrait', {package_id, character_id, trait_index})
}

</script>

<template>
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h5>{{ character.name }}</h5>
      </div>
      <div v-auto-animate class="card-body">
        <Loading v-if="isLoading" loading-type="list" />
        <template v-else >
          <!-- List Of traits -->
          <div v-for="(trait_id, trait_index) in storeCharacter.trait_ids" 
            class="row align-items-center mb-1"
            v-auto-animate
          >
            <template v-if="!trait_id._destroy" v-auto-animate>
              <div class="col-10 row p-0">
                <div class="col-10">
                  <multiselect 
                    v-model="trait_id.id" 
                    placeholder="Select trait"
                    :options="traitOptions"
                    valueProp="valueProp"
                    :searchable="true"
                    disabled
                  ></multiselect>
                </div>
                <div class="col-2">
                  <input class="form-control trait-value-input" 
                    type="number"
                    disabled
                    v-model="trait_id.value"
                  >
                </div>
              </div>
              <div class="col-2">
                <button class="btn remove-btn" @click="removeTrait(character.id, report.package_config.id, trait_index, trait_id)">
                  -
                </button>
              </div>
            </template>
          </div>
          
          <!-- input component -->
          <div class="row align-items-center mb-1">
            <form class="col-10 row p-0"
              @submit.prevent="addTrait(character.id, report.package_config.id)"
            > 
              <div class="col-10">
                <multiselect 
                  v-model="storeCharacter.tempTrait.id"
                  placeholder="Select trait"
                  :options="traitOptions"
                  valueProp="valueProp"
                  :searchable="true"
                ></multiselect>
              </div>
              <div class="col-2">
                <input class="form-control trait-value-input" 
                  v-model="storeCharacter.tempTrait.value"
                  type="number"
                  :min="report.package_config.options.min.value"
                  :max="report.package_config.options.max.value"
                  required
                >
              </div>
              <button :id="'addTraitBtn-' + report.package_config.package_type + character.id" 
                class="d-none" 
                type="submit"
              >
                Submit
              </button>
            </form>
            <div class="col-2">
              <button class="btn btn-light-success icon-btn" @click="addTraitFooterBtn(character.id, report.package_config.package_type)">
                +
              </button>
            </div>
          </div>
        </template>
        
      </div>
      <div class="card-footer py-3 text-end">
        <button class="btn btn-primary" 
          @click="addTraitFooterBtn(character.id, report.package_config.package_type)"
        >
          Add Trait
        </button>
      </div>
    </div>
  </div>
</template>